import { render } from "./DeviceStatusBadge.vue?vue&type=template&id=2d2946ee&scoped=true"
import script from "./DeviceStatusBadge.vue?vue&type=script&lang=js"
export * from "./DeviceStatusBadge.vue?vue&type=script&lang=js"

import "./DeviceStatusBadge.vue?vue&type=style&index=0&id=2d2946ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2946ee"]])

export default __exports__